import { AppComponentModule } from './app-component/app-component.module'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, OnsenModule } from 'ngx-onsenui'
import { TopComponent } from './top/top.component'
import { SettingComponent } from './setting/setting.component'
import { ClientAppComponent } from './client-app.component'
import { ComplianceComponent } from './compliance/compliance.component'
import { AlignerComponent } from './aligner/aligner.component'
import { ImageComponent } from './image/image.component'
import { CommunicationComponent } from './communication/communication.component'
import { TestComponent } from './test/test.component'
import { ClientAppRoutingModule } from './client-app.routing'
import { ScrollbarModule } from 'ngx-scrollbar'
import { LoginTokenComponent } from './login-token/login-token.component'
import { ActiveTokenComponent } from './active-token/active-token.component'
import { LoginAccountComponent } from './login-account/login-account.component'
import { NvD3Module } from 'ng2-nvd3'
import { NgCircleProgressModule } from 'ng-circle-progress'
import { GetUrlImagePipe } from '../../helper/getUrlImage.pipe'
import { CommonsModule } from '../commons/commons.module'
import { PipeModule } from '@app/pipes/pipe.module'
import { APP_CONFIG, ConfigService } from '@services/config.service'
import { RequestServices } from '@app/services'
import { ChatModule } from '@commons/chat/chat.module'

@NgModule({
    imports: [
        OnsenModule,
        ScrollbarModule,
        CommonModule,
        ClientAppRoutingModule,
        NvD3Module,
        CommonsModule,
        AppComponentModule,
        NgCircleProgressModule.forRoot({
            // set defaults here
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#0080ff',
            innerStrokeColor: '#53a9ff',
            animationDuration: 300,
        }),
        PipeModule,
        ChatModule,
    ],
    declarations: [
        ClientAppComponent,
        TopComponent,
        SettingComponent,
        ComplianceComponent,
        AlignerComponent,
        ImageComponent,
        CommunicationComponent,
        TestComponent,
        LoginTokenComponent,
        ActiveTokenComponent,
        LoginAccountComponent,
        GetUrlImagePipe,
    ],
    bootstrap: [ClientAppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    entryComponents: [
        TopComponent,
        SettingComponent,
        ComplianceComponent,
        AlignerComponent,
        ImageComponent,
        CommunicationComponent,
    ],
    exports: [
        GetUrlImagePipe,
    ],
    providers: [
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: (config: ConfigService) => () => config.load(),
            deps: [ConfigService, RequestServices],
            multi: true,
        },
        {
            provide: APP_CONFIG,
            useFactory: (config: ConfigService) => config.get(),
            deps: [ConfigService],
        },

    ],
})
export class ClientAppModule {
}



// WEBPACK FOOTER //
// ./src/app/client-app/client-app.module.ts